module.exports = {
  Visor3D: {
    Auto_rotate: "Rotar",
    Allow_fullscreen: "Permitir Pantalla Completa",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    color: "Color",
    opacity: "Opacidad",
    padding: "Padding",
    PluginName: "Visor de objetos 3D",
    radius: "Radio",
    // "Scroll": "Scroll",
    settings: "Configuración",
    source: "Origen",
    style: "Estilo de Plugin",
    URL: "URL",
  },
};
